import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { siteInfo, brandLogos } from "../mock";

const navItems = [
  { label: "Le Centre", href: "#le-centre" },
  { label: "CAP AEPE", href: "#cap-aepe" },
  { label: "La formation", href: "#la-formation" },
  { label: "Financements", href: "#financements" },
  { label: "Témoignages", href: "#temoignages" },
  { label: "Assistant IA", href: "#assistant" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-[#e6ded0] shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-3 group">
            <div className="relative w-12 h-12 rounded-xl bg-white border border-[#e6ded0] flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow p-1.5">
              <img src={brandLogos.cfmpe} alt="Logo CFMPE" className="w-full h-full object-contain" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-xl font-semibold text-[#0e3a3f]">{siteInfo.name}</span>
              <span className="text-[10px] uppercase tracking-widest text-[#2c7a80]/80 font-medium">Petite Enfance · Nice</span>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-[#0e3a3f]/80 hover:text-[#2c7a80] transition-colors relative py-2 group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2c7a80] group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${siteInfo.phone.replace(/\./g, "")}`}
              className="flex items-center gap-2 text-sm font-medium text-[#0e3a3f] hover:text-[#2c7a80] transition-colors"
            >
              <Phone className="w-4 h-4" />
              {siteInfo.phone}
            </a>
            <Button
              asChild
              className="bg-[#2c7a80] hover:bg-[#245e63] text-white rounded-full px-5 btn-primary"
            >
              <a href="#contact">Candidater</a>
            </Button>
          </div>

          <button
            className="lg:hidden p-2 rounded-lg text-[#0e3a3f] hover:bg-[#f5f1e8] transition-colors"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile nav */}
        {open && (
          <div className="lg:hidden pb-6 pt-2 space-y-1 border-t border-[#e6ded0] mt-1 bg-white/95 backdrop-blur-xl -mx-6 px-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="block py-3 text-base font-medium text-[#0e3a3f] hover:text-[#2c7a80] border-b border-[#f0e9d9] last:border-0"
              >
                {item.label}
              </a>
            ))}
            <div className="pt-4 flex flex-col gap-3">
              <a
                href={`tel:${siteInfo.phone.replace(/\./g, "")}`}
                className="flex items-center gap-2 text-sm font-medium text-[#0e3a3f]"
              >
                <Phone className="w-4 h-4" />
                {siteInfo.phone}
              </a>
              <Button asChild className="bg-[#2c7a80] hover:bg-[#245e63] text-white rounded-full">
                <a href="#contact" onClick={() => setOpen(false)}>Candidater</a>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
